import React, { useState } from "react";
import CreateNewBoxType from "../handleBoxes/CreateNewBoxType";
import MainStore from "../stores/MainStore";

const useDetailedBoxTypeModal = ({ firstTime, boxType }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { player } = MainStore();

  function openModal() {
    setModalOpen(true);
  }
  function closeModal() {
    setModalOpen(false);
  }
  return {
    open: openModal,
    close: closeModal,

    divs: (
      <div style={{ position: "relative" }}>
        {modalOpen && (
          <div
            className="divRow"
            style={{
              border: "5px solid grey",
              width: "1200px",
              height: "550px",
              overflow: "auto",
              position: "fixed",
              top: "20%",
              left: "20%",
              zIndex: 1111,
            }}
          >
            <CreateNewBoxType
              fromModal={true}
              firstTime={false}
              outsideBoxType={boxType}
              onBack={closeModal}
            />
          </div>
        )}
      </div>
    ),
  };
};

export default useDetailedBoxTypeModal;
